<div class="container">
  <div class="alert-icon">
    <img src="assets/icons/alert-circle-black.svg" />
  </div>
  <div class="banner-content">
    <div class="heading">Visual aid was unable to be displayed</div>
    <div class="sub-heading">
      <span class="text">
        Try displaying the aid again. If the issue persists, please reach out
        to</span
      >
      <span class="link">help&#64;quantified.ai</span>
    </div>
  </div>
</div>
